export default __webpack_public_path__ + "static/media/telegram.7ee80df5.svg";